export const selectors = {
    searchForm: '#film-search-form',
    searchInput: '.js-film-search-input',
    searchButton: '.js-search-button',
    clearSearchButton: '.js-clear-search',
    regionRadios: '.js-film-region-radio',
    formatSelect: '.js-film-format-select',
    yearSelect: '.js-film-year-select',
    genreSelect: '.js-film-genre-select',
    availableToWatchCheckbox: '.js-film-available-checkbox',
    resultsContainer: '.js-film-results',
    expandFilterButton: '.js-expand-filter',
    expandableFilter: '.js-expandable-filter-wrapper',
    clearAllButtons: '.js-clear-all',
    resultCount: '.js-results-count',
    noResultsContainer: '.js-no-results',
    loadingSkeletons: '.js-loading-skeletons'
};

const searchForm = document.querySelector(selectors.searchForm);

export const elements = {
    searchForm: searchForm,
    searchInput: document.querySelector(selectors.searchInput),
    searchButton: searchForm?.querySelector(selectors.searchButton),
    clearSearchButton: searchForm?.querySelector(selectors.clearSearchButton),
    regionRadios: document.querySelectorAll(selectors.regionRadios),
    formatSelect: document.querySelector(selectors.formatSelect),
    yearSelect: document.querySelector(selectors.yearSelect),
    genreSelect: document.querySelector(selectors.genreSelect),
    availableToWatchCheckbox: document.querySelector(selectors.availableToWatchCheckbox),
    resultsContainer: document.querySelector(selectors.resultsContainer),
    expandFilterButton: searchForm?.querySelector(selectors.expandFilterButton),
    expandableFilter: searchForm?.querySelector(selectors.expandableFilter),
    clearAllButtons: searchForm?.querySelectorAll(selectors.clearAllButtons),
    resultCount: searchForm?.querySelector(selectors.resultCount),
    noResultsContainer: document.querySelector(selectors.noResultsContainer),
    loadingSkeletons: document.querySelector(selectors.loadingSkeletons)
};
